/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Mobile category bar (sections/header.liquid). It lives here and not in theme.js so it survives a theme update.
 */
(function () {
  var root = document.documentElement,
      mobile = window.matchMedia('(max-width: 999px)'),
      bar = null,
      scroller = null,
      headerIsSticky = false,
      lastY = 0;

  // The edge fade only shows on the sides where there is actually more to scroll
  function updateEdges() {
    if (!bar) {
      return;
    }

    var max = scroller.scrollWidth - scroller.clientWidth;

    bar.classList.toggle('has-more-start', scroller.scrollLeft > 4);
    bar.classList.toggle('has-more-end', scroller.scrollLeft < max - 4);
  }

  // --category-bar-shift lets the sticky collection toolbar follow the bar, as --header-height includes the bar
  function setShift(shift) {
    root.style.setProperty('--category-bar-shift', shift + 'px');
  }

  function setHidden(hidden) {
    bar.classList.toggle('is-hidden', hidden);
    setShift(hidden ? bar.offsetHeight : 0);
  }

  function onScroll() {
    if (!bar || !headerIsSticky || !mobile.matches) {
      return;
    }

    var y = window.scrollY,
        stuckAt = parseInt(root.style.getPropertyValue('--announcement-bar-height')) || 0,
        height = bar.offsetHeight;

    if (bar.getAttribute('data-sticky') !== 'true') {
      // Not sticky: the bar leaves with the page, until it sits behind the header
      var shift = Math.min(Math.max(y - stuckAt, 0), height);

      bar.classList.add('is-following');
      bar.classList.toggle('is-hidden', shift >= height);
      bar.style.transform = shift > 0 && shift < height ? 'translateY(-' + shift + 'px)' : '';
      setShift(shift);
      return;
    }

    if (bar.getAttribute('data-hide-on-scroll') !== 'true' || y <= stuckAt + 60) {
      setHidden(false);
      lastY = y;
      return;
    }

    var delta = y - lastY;

    // Thresholds avoid flickering on micro-scrolls. We never hide while a menu/drawer has the page locked
    if (delta > 8 && !root.classList.contains('is-locked')) {
      setHidden(true);
    } else if (delta < -6) {
      setHidden(false);
    }

    if (Math.abs(delta) > 6) {
      lastY = y;
    }
  }

  function init() {
    bar = document.querySelector('.category-bar');
    root.style.removeProperty('--category-bar-shift');

    if (!bar) {
      return;
    }

    scroller = bar.querySelector('.category-bar__scroller');
    scroller.addEventListener('scroll', updateEdges, {passive: true});
    headerIsSticky = getComputedStyle(root).getPropertyValue('--header-is-sticky').trim() === '1';

    var current = bar.querySelector('[aria-current]');

    if (current) {
      scroller.scrollLeft = current.offsetLeft - (scroller.clientWidth - current.offsetWidth) / 2;
    }

    updateEdges();
    onScroll();
  }

  window.addEventListener('scroll', onScroll, {passive: true});
  window.addEventListener('resize', updateEdges);
  document.addEventListener('shopify:section:load', init);

  init();
})();

